export default __webpack_public_path__ + "static/media/banner-img.b53900d2.png";